import { getCurrentDateTime } from '@/api/time/currentTime';
import { ref } from 'vue';
import { addMilliseconds } from 'date-fns';

const serverTimeDifferenceInMilliseconds = ref(0);

const useServerTime = () => {
  const setup = async () => {
    const serverTimeInMs = new Date(await getCurrentDateTime()).getTime();
    serverTimeDifferenceInMilliseconds.value = serverTimeInMs - new Date().getTime();
  };

  const getServerTime = () => addMilliseconds(serverTimeDifferenceInMilliseconds.value, new Date());

  return {
    setup,
    getServerTime,
  };
};

export default useServerTime;
